import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const IntegrationCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 253px;
  height: 416px;
  margin: ${Spacing.S16} ${Spacing.S16} 0 0;
  padding: ${Spacing.S24} ${Spacing.S16};
  border: 1px solid ${Color.Grey200};
  border-radius: ${DefaultValue.BorderRadius};
  position: relative;
  background-color: ${Color.White};

  &:last-of-type {
    margin-right: 0;
  }
`
export const CardStatusLabelWrapper = styled.div`
  position: absolute;
  top: ${Spacing.S12};
  left: ${Spacing.S16};
`

export const CardContentWrapper = styled.div``

export const CardImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  margin-bottom: ${Spacing.S24};
  overflow: hidden;
`

export const CardDescriptionWrapper = styled.div`
  margin-top: ${Spacing.S8};
`

export const CardSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: ${Spacing.S8} 0;

  label {
    width: auto;
  }
`

export const CardActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S8};
  a {
    width: fit-content;
  }
`
